<!--
  File name: NoDataYet.vue
  Program Description:
    -  This component is used in the third tab of the PDBNF form when the
    condition of no checkboxes checked are met.

-->

<template>
  <v-container>
    <v-img
      :src="`${image}`"
      max-height="400"
      max-width="300"
      class="ma-auto"
    />
    <v-row
      class="pa-10"
      justify="center"
    >
      {{ message }}
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'AppBar',
  props: {
    image: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    }
  }
}
</script>
